// extracted by mini-css-extract-plugin
export default {"sum1":"style_sum1__Gwyrk"};